import { httpUrl } from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-lease`
let baseUrl2 = `${httpUrl.host}/gy-apartment`
let baseUrl3 = `${httpUrl.host}/gy-auth`
let baseUrl4 = `${httpUrl.host}/gy-config`
// let baseUrl = `${httpUrl.host}/yq-lease`
// let baseUrl2 = `${httpUrl.host}/gy-apartment`
// let baseUrl3 = `${httpUrl.host}/yq-auth`
// let baseUrl4 = `${httpUrl.host}/yq-config`

let api = {
  // 获取快捷入口配置
  getQuickAccessList: `${baseUrl3}/menu/getMenuListByAccountCode`,

  // 配置快捷入口
  configQuickAccessList: `${baseUrl3}/menu/save`,

  // 待办列表
  getWorkbenchList: `${baseUrl2}/homePage/getToDo`,

  // 获取首页数据
  getHomeData: `${baseUrl2}/homePage/home`,

  // 获取审批数量
  getCountApproveForMe: `${baseUrl2}/homePage/getCountApproveForMe`,

  // 获取首页楼栋数据
  getBuildingList: `${baseUrl2}/homePage/getBuildingList`,

  // 0-待我审批   1-我已审批
  getPageByApproveAccountCode: `${baseUrl}/contractApprove/getPageByApproveAccountCode`,

  // 展示30天内可收的金额
  getDueInItems: `${baseUrl}/workstation/getDueInItems`,

  // 展示全部逾期没有结算的客户
  getDueOverItems: `${baseUrl}/workstation/getDueOverItems`,

  // 近30天资金流水列表（区分租金，保证金，物业费，其他）
  getFellowBillList: `${baseUrl}/workstation/getFellowBillList`,

  // 账单跟进情况
  getmoneyFellowList: `${baseUrl}/workstation/getmoneyFellowList`,

  // 合同跟进分布
  getContractListGroupByFellower: `${baseUrl}/workstation/getContractListGroupByFellower`,

  // 合同到期监控情况
  getOverDateContractListDetail: `${baseUrl}/workstation/getOverDateContractListDetail`,

  // 新增客户统计
  getIncreaseCustomStatistics: `${baseUrl}/workstation/getIncreaseCustomStatistics`,

  // 合同签订统计
  getIncreaseContractStatistics: `${baseUrl}/workstation/getIncreaseContractStatistics`,

  // 合同退租统计
  getReduceContractStatistics: `${baseUrl}/workstation/getReduceContractStatistics`,

  // 获取平台端服务开通信息
  getYqServerConfig: `${baseUrl4}/config/getList`,

  // 获取版本更新日志
  getVesionPage: `${baseUrl2}/homePage/getVesionPage`,

  //满租率统计
  getRentRateStatistics: `${baseUrl}/overview/getRentRateOverview`
}

export { api }



// WEBPACK FOOTER //
// ./src/view/api/Workbench.js